import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { FarmContextProvider } from './FarmContext';
import { AppContext, AppContextProvider } from './AppContext';
import Shell from './Shell';
import { Login, Logout } from './Login';


// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, ...rest }) {
  let { user } = React.useContext(AppContext);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export const DEFAULT_PATH = "/comp/new";

export default function App () {
    return <AppContextProvider>
        <Router>
            <Switch>
                <PrivateRoute path="/comp/:compId">
                  <FarmContextProvider model="comp">
                    <Shell />
                  </FarmContextProvider>
                </PrivateRoute>
                <PrivateRoute path="/fkd/:fkdId">
                  <FarmContextProvider model="knowledge">
                    <Shell />
                  </FarmContextProvider>
                </PrivateRoute>
                <Route path="/login"> <Login /> </Route>
                <Route path="/logout"> <Logout /> </Route>
                <Route path="/*" exact component={({ location }) => <Redirect to={{...location, pathname: DEFAULT_PATH}} />} />
            </Switch>
        </Router>
    </AppContextProvider>
}